import { loadPlannerDraft } from "/js/financialPlannerDraft.js";

const desktopMediaQuery = window.matchMedia("(min-width: 1025px)");

function setupPillarCarousel(root) {
  const viewport = root.querySelector("[data-carousel-viewport]");
  const section = root.closest(".finance-section");
  const prevButton = section?.querySelector("[data-carousel-prev]");
  const nextButton = section?.querySelector("[data-carousel-next]");
  const dotsRoot = root.querySelector("[data-carousel-dots]");
  const cards = Array.from(viewport?.querySelectorAll(".finance-pillar-card") ?? []);

  if (!viewport || !prevButton || !nextButton || !dotsRoot || cards.length === 0) {
    return;
  }

  const dots = cards.map((_, index) => {
    const dot = document.createElement("button");
    dot.type = "button";
    dot.className = "finance-carousel-dot";
    dot.setAttribute("aria-label", `Vai allo strumento ${index + 1}`);
    dot.addEventListener("click", () => {
      const targetCard = cards[index];
      if (!targetCard) {
        return;
      }

      viewport.scrollTo({
        left: targetCard.offsetLeft,
        behavior: "smooth",
      });
    });
    dotsRoot.appendChild(dot);
    return dot;
  });

  const updateActiveDot = () => {
    const currentScroll = viewport.scrollLeft;
    let activeIndex = 0;
    let smallestDistance = Number.POSITIVE_INFINITY;

    cards.forEach((card, index) => {
      const distance = Math.abs(card.offsetLeft - currentScroll);
      if (distance < smallestDistance) {
        smallestDistance = distance;
        activeIndex = index;
      }
    });

    dots.forEach((dot, index) => {
      dot.classList.toggle("is-active", index === activeIndex);
      dot.setAttribute("aria-current", index === activeIndex ? "true" : "false");
    });
  };

  const updateButtons = () => {
    if (!desktopMediaQuery.matches) {
      prevButton.disabled = true;
      nextButton.disabled = true;
      updateActiveDot();
      return;
    }

    const maxScrollLeft = viewport.scrollWidth - viewport.clientWidth;
    const currentScroll = Math.round(viewport.scrollLeft);

    prevButton.disabled = currentScroll <= 4;
    nextButton.disabled = currentScroll >= Math.max(0, maxScrollLeft - 4);
    updateActiveDot();
  };

  const getCardStep = () => {
    const firstCard = viewport.querySelector(".finance-pillar-card");
    if (!firstCard) {
      return viewport.clientWidth;
    }

    const styles = window.getComputedStyle(viewport.querySelector(".finance-pillar-grid--carousel"));
    const gap = Number.parseFloat(styles.columnGap || styles.gap || "0");
    return firstCard.getBoundingClientRect().width + gap;
  };

  const scrollByCards = (direction) => {
    if (!desktopMediaQuery.matches) {
      return;
    }

    viewport.scrollBy({
      left: getCardStep() * direction,
      behavior: "smooth",
    });
  };

  prevButton.addEventListener("click", () => scrollByCards(-1));
  nextButton.addEventListener("click", () => scrollByCards(1));
  viewport.addEventListener("scroll", updateButtons, { passive: true });

  const handleResize = () => {
    if (!desktopMediaQuery.matches) {
      viewport.scrollLeft = 0;
    }

    updateButtons();
  };

  if (typeof desktopMediaQuery.addEventListener === "function") {
    desktopMediaQuery.addEventListener("change", handleResize);
  } else {
    desktopMediaQuery.addListener(handleResize);
  }

  window.addEventListener("resize", handleResize, { passive: true });
  updateButtons();
}

document.querySelectorAll("[data-pillar-carousel]").forEach(setupPillarCarousel);

// Se c'e' una bozza del planner salvata su questo dispositivo, le CTA invitano a riprenderla
if (loadPlannerDraft()) {
  document.querySelectorAll('a[href="/check-up-finanziario/wizard"] .button-text').forEach((label) => {
    label.textContent = "Riprendi il check-up";
  });
}
